<<template>
<div ref="basePanel" style="text-align: center;">
  <h1>欢迎使用 HR系统</h1>
</div>
</template>


<script>
import data from "./data";
import mixin from "@/fui/mixin";

export default {

  data() {
    return {
      config: data
    };
  },
  mixins:[mixin.list]
};
</script>
